import { Injectable } from '@angular/core';

import { AbstractToolService } from './abstract-tool.service';
import { DesignHostContainer } from '../types';

@Injectable({
  providedIn: 'root'
})
export class SelectToolService extends AbstractToolService {
  constructor() {
    super();
  }

  do(host: DesignHostContainer, args: any) {
    if (this.designer.selected.designHost) {
      this.designer.selected.designHost.selected = false;
    }

    host.selected = true;
    this.designer.selected.designHost = host;
    this.designer.selected.control = args.control;
    this.designer.selected.specification = args.specification;

    super.raiseCompletedEvent(args);
  }
}
